import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { routes } from '@/core/router/routes';
import { Routes } from '@/core/router/routes.types';
import { getUserToken } from '@/redux/user';
import { useGetRestaurantChannelsQuery } from '@/services/innovorder/channel/channel.endpoints';
import { ChannelId } from '@/services/innovorder/channel/channel.type';

export const useRestaurantTabRoutes = () => {
    const token = useSelector(getUserToken);
    const { restaurantId } = useParams<{ restaurantId: string }>();

    const { data: channels } = useGetRestaurantChannelsQuery(
        { restaurantId: restaurantId!, token: token! },
        { skip: !restaurantId || !token },
    );

    const hasKioskChannel = useMemo(
        () => !channels || Object.values(channels).some((ch) => ch.channelId === ChannelId.KIOSK),
        [channels],
    );

    return useMemo(() => {
        const kioskChannelEnabledRoutes: (Routes | undefined)[] = [Routes.RestaurantPromotionalBanners];

        return routes
            .filter(({ tab }) => tab === 'restaurants')
            .filter(({ path }) => hasKioskChannel || !kioskChannelEnabledRoutes.includes(path));
    }, [hasKioskChannel]);
};
